import {
  Entity,
  Column,
  PrimaryGeneratedColumn,
  JoinColumn,
  ManyToOne,
  OneToMany,
} from "typeorm";
import { LicenseRequest, User } from ".";
import { AdhocAgreement } from "./AdhocAgreement";

@Entity()
export class AdhocProject {
  @PrimaryGeneratedColumn() id: number;

  @Column("varchar") name: string;

  @Column("int") userId: number;
  @ManyToOne(() => User)
  @JoinColumn()
  user: User;

  @OneToMany(() => LicenseRequest, (licenseRequest) => licenseRequest.project)
  @JoinColumn()
  licenseRequests: LicenseRequest;

  @OneToMany(
    () => AdhocAgreement,
    (adhocAgreement) => adhocAgreement.adhocProject
  )
  adhocAgreements: AdhocAgreement[];

  @Column("boolean", { default: true })
  active: boolean;

  @Column("datetime") createdAt: Date;
  @Column("datetime") updatedAt: Date;
}
